export default __webpack_public_path__ + "static/media/zimyo-logo.71a14f12.png";